/* eslint-disable yola/react/require-default-props */
import React, { forwardRef, useCallback } from 'react';
import { useController } from 'react-hook-form';
import Autocomplete from '../autocomplete';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';

const defaultRules = {};

const AutocompleteField = forwardRef(
  ({ rules = defaultRules, onChange = noop, onBlur = noop, control, name, ...otherProps }, ref) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    const handleChange = useCallback(
      (option) => {
        field.onChange(option?.value);
        onChange?.(option);
      },
      [field, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();
      onBlur?.();
    }, [field, onBlur]);

    return (
      <React.Fragment>
        <Autocomplete
          {...otherProps}
          invalid={fieldState.invalid}
          onChange={handleChange}
          onBlur={handleBlur}
          defaultInputValue={field.value}
          ref={ref}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

AutocompleteField.displayName = 'AutocompleteField';

export default AutocompleteField;
